export const getProvenceData = () => ({
  name: "Provence",
  country: "France",
  description: "La Provence est la plus ancienne région viticole de France, célèbre pour ses vins rosés et ses paysages méditerranéens.",
  type: "region",
  subregions: {
    bandol: {
      name: "Bandol",
      description: "Bandol est l'appellation la plus prestigieuse de Provence, réputée pour ses vins rouges puissants et ses rosés élégants.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols calcaires et galets roulés",
        viticulture: "Rendements limités, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Mourvèdre", "Grenache", "Cinsault", "Syrah"],
        white: ["Clairette", "Ugni Blanc", "Bourboulenc"]
      },
      wineStyles: {
        red: "Vins puissants et structurés avec un excellent potentiel de vieillissement",
        rosé: "Rosés élégants et fruités, secs et équilibrés",
        white: "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges grillées, poissons méditerranéens, fromages affinés"
    },
    cotes_provence: {
      name: "Côtes de Provence",
      description: "Les Côtes de Provence produisent principalement des vins rosés de qualité, représentant 80% de la production.",
      characteristics: {
        climate: "Climat méditerranéen avec influences maritimes",
        soil: "Sols variés : calcaires, schisteux, argilo-calcaires",
        viticulture: "Rendements modérés, vendanges mécaniques et manuelles"
      },
      grapeVarieties: {
        red: ["Grenache", "Syrah", "Mourvèdre", "Cinsault", "Carignan"],
        white: ["Rolle", "Clairette", "Ugni Blanc", "Sémillon"]
      },
      wineStyles: {
        red: "Vins rouges fruités et accessibles",
        rosé: "Rosés frais et fruités, parfaits pour l'apéritif",
        white: "Vins blancs secs et aromatiques"
      },
      foodPairing: "Cuisine méditerranéenne, salades, poissons, fromages frais"
    },
    cassis: {
      name: "Cassis",
      description: "Cassis est réputé pour ses vins blancs secs et minéraux, produits sur les côtes méditerranéennes.",
      characteristics: {
        climate: "Climat méditerranéen avec influences maritimes",
        soil: "Sols calcaires et argilo-calcaires",
        viticulture: "Rendements limités, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Marsanne", "Clairette", "Ugni Blanc", "Bourboulenc", "Sauvignon Blanc"],
        red: ["Grenache", "Mourvèdre", "Cinsault"]
      },
      wineStyles: {
        white: "Vins blancs secs, minéraux et aromatiques",
        red: "Vins rouges légers et fruités",
        rosé: "Rosés frais et élégants"
      },
      foodPairing: "Poissons et fruits de mer, bouillabaisse, fromages de chèvre"
    }
  },
  mapAreas: [
    { region: "Bandol", x: 65, y: 75, color: "#4B164C", size: 6 },
    { region: "Côtes de Provence", x: 60, y: 70, color: "#6d2c7a", size: 8 },
    { region: "Cassis", x: 68, y: 72, color: "#8a4a8a", size: 4 }
  ],
  statistics: {
    totalArea: "27,000 ha",
    production: "1.2 million hectolitres",
    roséPercentage: "80%",
    redPercentage: "15%",
    whitePercentage: "5%"
  },
  history: "La viticulture en Provence remonte à l'Antiquité, avec l'arrivée des Phocéens au VIe siècle av. J.-C. La région a développé une tradition viticole unique, influencée par le climat méditerranéen et les sols calcaires."
}); 